module.exports = __webpack_public_path__ + "media/images/index/step2-901a98de7f9c891b7df1f948939c17f5.svg";